import * as React from "react";
import {cx} from "emotion";

import "./top-select.scss";

import {cs}          from "@Common/react/chain-services";
import {fragments}   from "@Common/react/fragments";
import {GlobalEvent} from "@Common/react/global-event";
import {keyed}       from "@Common/react/keyed";
import {Static2}     from "@Common/react/static-2";
import {UseState}    from "@Common/react/use-state";
import {Checkbox}    from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {isChildDom}  from "@Common/utils/browser/is-child-dom";

import {checkMidwaySelect} from "../common/check-midway-select";

export const TopSelect = ({className, isSelected, seriesList, deselect, select, isUnselectable}) => cs(
    ["expanded", (_, next) => UseState({next})],
    ["domRef", (_, next) => Static2({next})],
    ({expanded, domRef}) => (
        <div className={cx("top-select-31o", className)} ref={domRef.set}>
            <div {...{
                className: "box",
                onClick: () => expanded.change(v => !v),
                "xd-qa-type": "dropdown",
                "xd-qa-name": "Select all Series",
            }}>
                {cs(
                    ["selected", (_, next) => next(checkMidwaySelect(seriesList.map(({editions}) => editions).flat(), (pe) => isSelected(pe.editionId)))],
                    ({selected}) => {
                        const disabled = !seriesList.some(({editions}) => editions.some((e) => isUnselectable(e.editionId)));

                        return Checkbox({
                            checked: selected,
                            size: "small",
                            disabled,
                            onClick: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (selected === true) {
                                    deselect(seriesList.map(({editions}) => editions).flat().map((pe) => pe.editionId).filter((eId) => isSelected(eId) && isUnselectable(eId)));
                                } else {
                                    select(seriesList.map(({editions}) => editions).flat().map((pe) => pe.editionId).filter((id) => !isSelected(id)));
                                }
                            },
                            xdQaName: "Select all",
                        });
                    },
                )}

                <div {...{
                    className: "label",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Select all Series",
                }}>
                    {seriesList.filter((s) => s.editions.some((pe) => isSelected(pe.editionId))).length}{" "}
                    of{" "}
                    {seriesList.length}{" "}
                    Series Selected
                </div>

                <div className="indicator">
                    <i className="fa fa-caret-down"/>
                </div>
            </div>

            {expanded.value && fragments(
                GlobalEvent({
                    useCapture: true,
                    eventName: "click",
                    action: (e) => {
                        if (isChildDom(e.target, domRef.get())) {
                            return;
                        }
                        expanded.onChange(false);
                        e.preventDefault();
                        e.stopPropagation();
                        // return false;
                    },
                }),
                <div className="expansion">
                    {seriesList.map(({series, editions}) => cs(
                        keyed(series.id),
                        ["selected", (_, next) => next(checkMidwaySelect(editions, (pe) => isSelected(pe.editionId)))],
                        ({selected}) => (
                            <div {...{
                                className: cx("series", {
                                    disabled: !editions.some((e) => isUnselectable(e.editionId)),
                                }),
                                onClick: (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (selected === true) {
                                        deselect(editions.map((pe) => pe.editionId).filter((eId) => isSelected(eId) && isUnselectable(eId)));
                                    } else {
                                        select(editions.map((pe) => pe.editionId).filter((id) => !isSelected(id)));
                                    }
                                },
                                "xd-qa-type": "card",
                                "xd-qa-name": "Series " + series.name,
                            }}>

                                {(() => {
                                    const checked = checkMidwaySelect(editions, (pe) => isSelected(pe.editionId));
                                    const disabled = !editions.some((e) => isUnselectable(e.editionId));
                                    return Checkbox({
                                        checked,
                                        size: "small",
                                        disabled,
                                        xdQaName: "Select series",
                                    });
                                })()}

                                <div {...{
                                    className: "name",
                                    "xd-qa-type": "label",
                                    "xd-qa-name": "Series " + series.name,
                                }}>
                                    {series.name}
                                </div>
                            </div>
                        )
                    ))}
                </div>
            )}
        </div>
    ),
);

